/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import BlueBannerButtons from '../BlueBannerButtons/BlueBannerButtons';

const useStyles = makeStyles(theme => ({
    root: {
        // flexGrow: 1
    },
    appbar: {
        display: 'block',
        minHeight: 180,
        background: theme.palette.appBarGradient,
        boxShadow: 'none',
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    appbarSmall: {
        display: 'block',
        minheight: 196,
        background: theme.palette.appBarGradient,
        boxShadow: 'none',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    toolbar: {
        height: '100%',
        width: '100%',
        [theme.breakpoints.down('850')]: {
            display: 'flex',
            flexDirection: 'column'
        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'baseline'
        }
    },
    bannerTextContainer: {
        height: '96%',
        maxWidth: '1220px',
        paddingLeft: '27px',
        paddingRight: '27px',
        [theme.breakpoints.down('850')]: {
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '32px',
        }
    },
    title: {
        fontSize: theme.fontVars.title,
        fontFamily: theme.fontFamily.light,
        lineHeight: theme.spacingVars.xxlarge,
        paddingBottom: theme.gutterFPS * 2,
        [theme.breakpoints.down('sm')]: {
            lineHeight: theme.spacingVars.xlarge
        },
        [theme.breakpoints.down('440')]: {
            paddingRight: 18
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.fontVars.xlarge
        }
    },
    caption: {
        fontSize: theme.fontVars.medium,
        fontFamily: theme.fontFamily.reg,
        lineHeight: theme.fontVars.mediumLH,
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacingVars.xmedium
        }

    },
    breadCrumbs: {
        paddingTop: '16px',
        paddingBottom: '24px',
        lineHeight: '12px',
        fontSize: '12px',
        color: theme.palette.white,
    },
    breadcrumbsLink: {
        color: theme.palette.white,
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.paleBlue
        }
    },
    breadcrumbsStatic: {
        fontSize: '12px',
        color: theme.palette.paleBlue
    },
    progressText: {
        fontSize: '12px',
        color: theme.palette.white,
        paddingRight: '16px',
        paddingTop: '12px',
        fontFamily: theme.fontFamily.reg,

    },
    linkBox: {
        display: 'flex',
        marginLeft: 'auto',
        alignSelf: 'center',
        [theme.breakpoints.down('850')]: {
            alignSelf: 'flex-end',
        }

    },
    titleCaptionContainer: {
        marginBottom: 48,
        color: theme.palette.white,
        [theme.breakpoints.up('sm')]: {
            paddingRight: 32
        },
        [theme.breakpoints.down('850')]: {
            marginBottom: 32
        }
    }
}));

const BlueBannerStatic = (props) => {
    const { showBreadcrumbs, breadcrumbs, showBannerButtons, header, subheader } = props;
    const classes = useStyles();
    // const url =
    //     window && window.location
    //         ? `${window.location.protocol}//${window.location.hostname}:${
    //         window.location.port
    //         }`
    //         : 'http://localhost:3000';
    const originURL = window.location.origin;
    const showProgressText = window.location.pathname.includes(
        '/usis/advice/fps/profile'
    );
    // const MyAccountsUrl = `${url}/usis/my-accounts/dashboard`;
    return (
        <div className={classes.root}>
            <AppBar className={classes.appbar} position="static" id='blue-banner'>
                <Container fixed className={classes.bannerTextContainer}>
                    <Breadcrumbs className={classes.breadCrumbs} id='breadcrumbs'>
                        {showBreadcrumbs && breadcrumbs.map(breadcrumb =>
                                breadcrumb.url ?
                                    <Link
                                        color="inherit"
                                        href={`${originURL}/${breadcrumb.url}`}
                                        underline="none"
                                        className={classes.breadcrumbsLink}
                                    >
                                        {breadcrumb.displayText}
                                    </Link>
                                :
                                    <Typography className={classes.breadcrumbsStatic}>
                                        {breadcrumb.displayText}
                                    </Typography>
                        )}
                    </Breadcrumbs>
                    <Toolbar className={classes.toolbar} disableGutters>
                        <Box
                            className={classes.titleCaptionContainer}
                            component="div"
                            display="block"
                        >
                            <Typography
                                className={classes.title}
                                variant="h4"
                                component="h2"
                                color="inherit"
                                id='banner-title'

                            >
                                    {header ||
                                        <span><Typography
                                            className={classes.title}
                                            display='inline'
                                            variant='h4'
                                            component='h2'
                                            noWrap
                                        >
                                            T. Rowe Price
                                        </Typography> Planning Service</span>
                                    }
                            </Typography>
                            <Typography
                                className={classes.caption}
                                variant="caption"
                                gutterBottom
                                id='banner-sub-text'
                            >
                                {subheader ||
                                    'Personalized, point-in-time advice for your retirement and other financial goals.'
                                }
                            </Typography>
                        </Box>
                        <Box className={classes.linkBox}
                        >
                            {showProgressText && (
                                <Typography
                                    className={classes.progressText}
                                    variant="h4"
                                    component="h2"
                                    color="inherit"
                                >
                                    Your progress auto-saves
                                </Typography>
                            )}
                            { showBannerButtons && <BlueBannerButtons /> }
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
};

function BlueBanner({ showBreadcrumbs, breadcrumbs, showBannerButtons = true, header, subheader }) {
    return <BlueBannerStatic showBreadcrumbs={showBreadcrumbs} breadcrumbs={breadcrumbs} showBannerButtons={showBannerButtons} header={header} subheader={subheader} />;
}

// export default withRouter(BlueBanner);
export default BlueBanner;